import {Header, Tabs} from '@/components';
import SystemHealthBanner from '@/components/SystemHealthBanner';
import type {TabItem} from '@/types';

import NameResolutionCache from './Cache/NameResolutionCache';
import ResolverConfiguration from './ResolverConfiguration';

const resolverTabs: TabItem[] = [
  {
    id: 'configuration',
    title: 'Configuration',
    content: <ResolverConfiguration />,
  },
  {id: 'cache', title: 'Cached lookups', content: <NameResolutionCache />},
];

/**
 * Processors -> Resolvers.
 *
 * Sibling of Corridors, not a tab inside it. Corridors is scoped by audience
 * (retail / portal / API) because a corridor names a different processor per
 * surface; resolvers are user-agnostic, one value per currency shared by all
 * three, so a target tab would mean something different in each screen.
 *
 * The tabs here split the configuration from its results: which provider each
 * currency resolves names with, and the name lookups those providers have
 * cached (where one can be invalidated so the next lookup goes live).
 */
const ProcessorResolvers = () => (
  <main className="mt-10 mb-5 mx-4 md:mx-10">
    <Header title="Processor Resolvers" />
    <SystemHealthBanner reason="Resolvers only work while the partner behind them is answering. If account name lookups or card saves start failing, the system health dashboard shows which partner is rejecting or timing out calls." />
    <Tabs tabs={resolverTabs} queryKey="tab" />
  </main>
);

export default ProcessorResolvers;
